import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll every route-change back to the top.
 * Lenis (smooth-scroll) instantiates fresh inside each page's useLenis(),
 * so the effect below only has to reset the native scroll offset before
 * the next page's Lenis attaches. Runs on pathname change only — hash
 * jumps (#worlds, #library, …) are left alone.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Ignore in-page hash targets — they should honour their anchor.
    if (window.location.hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  return null;
}
